<template>
  <LegalDocument
    title="شروط الاستخدام"
    subtitle="تحدّد هذه الشروط القواعد المنظِّمة لاستخدام منصة أ/ مصطفى حسني التعليمية. يُرجى قراءتها بعناية قبل استخدام الخدمة."
    last-updated="14 يوليو 2026"
    counterpart="privacy"
  >
    <template #icon>
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M14 2v6h6M9 13l2 2 4-4" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </template>

    <p class="legal-intro">
      تحكم شروط الاستخدام هذه علاقتك بمنصة <strong>أ/ مصطفى حسني - مدرس الكيمياء</strong>،
      المتاحة عبر <a href="https://moustafahosney.com" target="_blank" rel="noopener">moustafahosney.com</a>
      وتطبيق الهاتف المرتبط بها (يُشار إليها بـ«المنصة»). باستخدامك للمنصة فإنك تُقرّ بموافقتك
      الكاملة على هذه الشروط.
    </p>

    <h2>1. قبول الشروط</h2>
    <p>
      بمجرد تسجيلك في المنصة أو استخدامك لأي من خدماتها، فإنك تُقر بأنك قرأت هذه الشروط وفهمتها
      ووافقت على الالتزام بها. إذا كنت طالبًا دون السن القانونية الكاملة، فإن استخدامك للمنصة
      يتم بعلم وموافقة ولي أمرك الذي يوافق بدوره على هذه الشروط نيابةً عنك. إذا كنت لا توافق على
      أي بند من هذه الشروط، يُرجى التوقّف عن استخدام المنصة.
    </p>

    <h2>2. مسؤوليات الطالب</h2>
    <p>يلتزم الطالب المستخدم للمنصة بما يلي:</p>
    <ul>
      <li>تقديم بيانات صحيحة ودقيقة وحديثة عند التسجيل، والحفاظ على تحديثها.</li>
      <li>استخدام المنصة للأغراض التعليمية الشخصية فقط.</li>
      <li>عدم مشاركة حسابه أو محتوى المنصة مع أي طرف آخر.</li>
      <li>احترام حقوق الملكية الفكرية للمحتوى وعدم نسخه أو إعادة نشره.</li>
      <li>التصرّف بأمانة وعدم محاولة الغش في الامتحانات أو الواجبات.</li>
    </ul>

    <h2>3. أمان الحساب</h2>
    <p>
      يتم الدخول إلى المنصة عبر <strong>رقم الحجز (Reservation ID)</strong> ورقم هاتف الطالب.
      أنت مسؤول عن الحفاظ على سرية بيانات الدخول الخاصة بك وعدم إتاحتها للآخرين. تُعد جميع الأنشطة
      التي تتم من خلال حسابك مسؤوليتك الشخصية. في حال اشتباهك بأي استخدام غير مصرّح به لحسابك،
      يجب إبلاغنا فورًا لاتخاذ الإجراء المناسب.
    </p>

    <h2>4. الاستخدام التعليمي فقط</h2>
    <p>
      المنصة وكل ما تحتويه من دروس وشروحات وامتحانات وواجبات مخصّصة للاستخدام التعليمي الشخصي
      للطالب المشترك فقط. يُمنع استخدام المنصة لأي غرض تجاري أو ربحي، كما يُمنع إعادة بيع أو
      توزيع أو بثّ المحتوى بأي وسيلة كانت.
    </p>

    <h2>5. الاشتراك والمدفوعات</h2>
    <p>
      يتطلّب الوصول إلى بعض خدمات المنصة الاشتراك أو الحجز المسبق. تُحدَّد قيمة الاشتراك وشروطه
      وفق ما هو معلن عند التسجيل أو الحجز. يُقرّ الطالب/ولي الأمر بأن رسوم الاشتراك مقابل خدمة
      تعليمية، وتخضع سياسة السداد والاسترداد للأحكام المعلنة وقت الحجز أو المتفق عليها مع إدارة
      المنصة. لا تُعالَج المدفوعات وتُخزَّن بيانات بطاقات الدفع داخل المنصة.
    </p>

    <h2>6. ملكية المحتوى</h2>
    <p>
      جميع المواد التعليمية المنشورة على المنصة — بما في ذلك الشروحات والفيديوهات والملفات
      والامتحانات والواجبات والتصميمات — هي ملك خاص لـ<strong>أ/ مصطفى حسني</strong>
      أو الجهات المرخِّصة له، ومحمية بموجب قوانين حقوق الملكية الفكرية.
    </p>

    <h2>7. الملكية الفكرية</h2>
    <p>
      يُمنح الطالب ترخيصًا شخصيًا محدودًا وغير قابل للنقل لاستخدام المحتوى لأغراض دراسته فقط.
      لا يجوز نسخ أو تعديل أو توزيع أو نشر أو بيع أو إنشاء أعمال مشتقة من أي جزء من المنصة أو
      محتواها دون إذن كتابي مسبق. تظل جميع الحقوق غير الممنوحة صراحةً محفوظة لصاحب المنصة.
    </p>

    <h2>8. الأنشطة المحظورة</h2>
    <p>يُحظر على المستخدم القيام بأي من الأنشطة التالية:</p>
    <ul>
      <li>مشاركة بيانات الدخول أو السماح لغير المشترك باستخدام الحساب.</li>
      <li>تسجيل أو تصوير أو تنزيل أو إعادة نشر المحتوى بأي طريقة.</li>
      <li>محاولة اختراق المنصة أو تعطيلها أو الوصول غير المصرّح به إلى أنظمتها أو بيانات مستخدمين آخرين.</li>
      <li>استخدام برامج آلية أو وسائل احتيالية للتلاعب بالنتائج أو الامتحانات.</li>
      <li>نشر أي محتوى مخالف للقانون أو الآداب العامة عبر المنصة.</li>
    </ul>

    <h2>9. الإيقاف أو الإنهاء</h2>
    <p>
      نحتفظ بالحق في تعليق أو إنهاء حساب أي مستخدم يخالف هذه الشروط أو يسيء استخدام المنصة، دون
      إشعار مسبق وعند الاقتضاء، مع الاحتفاظ بكافة الحقوق القانونية. كما يحق للطالب/ولي الأمر
      إنهاء استخدام المنصة في أي وقت عبر التوقّف عن استخدامها أو طلب حذف الحساب.
    </p>

    <h2>10. إخلاء المسؤولية</h2>
    <p>
      تُقدَّم المنصة ومحتواها «كما هي» بهدف دعم العملية التعليمية. ورغم حرصنا على دقة المحتوى
      وجودته، فإننا لا نضمن خلوّه التام من الأخطاء أو توفّر الخدمة دون انقطاع في جميع الأوقات.
      لا تُعد المنصة بديلًا عن جهد الطالب الشخصي، ولا نضمن تحقيق نتائج دراسية محدّدة.
    </p>

    <h2>11. حدود المسؤولية</h2>
    <p>
      في حدود ما يسمح به القانون، لا يتحمّل صاحب المنصة أو القائمون عليها المسؤولية عن أي أضرار
      مباشرة أو غير مباشرة أو تبعية قد تنشأ عن استخدام المنصة أو تعذّر الوصول إليها، بما في ذلك
      الأعطال التقنية أو انقطاع الخدمة أو فقدان البيانات الناتج عن أسباب خارجة عن إرادتنا المعقولة.
    </p>

    <h2>12. التعديلات على الشروط</h2>
    <p>
      قد نقوم بتحديث هذه الشروط من وقت لآخر. سيظهر تاريخ «آخر تحديث» في أعلى الصفحة عند إجراء أي
      تعديل، ويُعد استمرارك في استخدام المنصة بعد نشر التعديلات موافقةً منك على الشروط المعدّلة.
    </p>

    <h2>13. القانون الحاكم</h2>
    <p>
      تخضع هذه الشروط وتُفسَّر وفقًا لقوانين <strong>جمهورية مصر العربية</strong>، وتختص
      المحاكم المصرية بالنظر في أي نزاع قد ينشأ عن استخدام المنصة أو يتعلّق بهذه الشروط.
    </p>

    <h2>14. التواصل معنا</h2>
    <div class="legal-contact">
      <p style="margin-bottom:.5rem">
        لأي استفسار بخصوص شروط الاستخدام، يمكنك التواصل معنا عبر:
      </p>
      <ul style="margin-bottom:0">
        <li>البريد الإلكتروني: <a href="mailto:info@ahmedhawam.com">info@ahmedhawam.com</a></li>
        <li>واتساب: <a href="https://wa.me/201280194879" target="_blank" rel="noopener">+20 12 80194879</a></li>
        <li>الموقع الإلكتروني: <a href="https://moustafahosney.com" target="_blank" rel="noopener">moustafahosney.com</a></li>
      </ul>
    </div>
  </LegalDocument>
</template>

<script>
import LegalDocument from '@/components/common/LegalDocument.vue';
import { applySeoMeta } from '@/composables/useSeoMeta';

export default {
  name: 'TermsOfServicePage',
  components: { LegalDocument },
  mounted() {
    this._seoCleanup = applySeoMeta({
      title: 'شروط الاستخدام | أ/ مصطفى حسني - مدرس الكيمياء',
      description:
        'شروط استخدام منصة أ/ مصطفى حسني التعليمية لمادة الكيمياء: قواعد الاستخدام، مسؤوليات الطالب، الاشتراك، الملكية الفكرية، وحدود المسؤولية.',
      canonical: 'https://moustafahosney.com/terms-of-service',
      type: 'article',
    });
  },
  beforeUnmount() {
    if (this._seoCleanup) this._seoCleanup();
  },
};
</script>
